module.exports = __webpack_public_path__ + "img/Help_icon.bad44ad2.svg";